/**
 * @param locale {string} - the country locale you wish to get data for
 * @param alias {string} - for renaming the query for ease of use
 *
 * @TODO use the alias buttonLabel instead of linkText
 */
const error = (locale, alias = "") => `
  ${alias ? `${alias}:` : ""} globalErrorPage (locale: ${locale}) {
    title
    message
    buttonLabel:linkText
    image {
      url
      alt
    }
  }
`;
export default error;
